var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99 6.4V16.82h16.105V6.4H3.99zm13.895 1.263l-5.757 4.143-5.82-4.143h11.577zm-12.632.799L9 11.137l-3.746 3.057V8.462zm.316 7.096l4.494-3.67 2.068 1.46 2.062-1.482 4.494 3.692H5.57zm13.263-1.516l-3.574-2.927 3.574-2.565v5.492z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/Notification.ce2cea4b.svg";
export { SvgNotification as ReactComponent };